define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/AddPath",
	"csi/def/Relationship",
	"csi/heading/Ref",
	"csi/state/rootStore"
], function(declare,lang,AddPath,Relationship,Ref,{ routerStore }) {

	return declare(Ref, {
		getStoreRelationship: function(/*Context*/ctx, /*Heading*/h) {
			// summary: need special code here because MerchProduct is owned by MerchCollection, but created under MerchCollectionVersion
			return lang.mixin(new Relationship(), {
				m_typeNode: "MerchProductSubtype",
				m_url: routerStore.getBreadcrumbNodeURL("MerchCollection"),
				m_addPaths: [lang.mixin(new AddPath(), {
					m_path: "Child:Subtype/Child:Settings/Child:ChildrenSubtypes"
				})]
			});
		}
	});
});